import {
    component,
    dateField,
    EntityData,
    field,
    identifier,
    LocalisableEntityData,
    transientField
} from "@fedeltapointofsale/data-client";
import {ContactData} from "../../contact/contact.data";
import {PositionData} from "../position/position.data";
import {AccessRoleReferenceData} from "../access-role/access-role.data";


export class UserBiometricData extends EntityData<UserBiometricData> {
    @identifier userBiometricId: number;
}

export class UserData extends EntityData<UserData> {
    @identifier userId: number;
    @field name: string;
    @field password: string;
    @field firstName: string;
    @field lastName: string;
    @field pin: string;
    @field swipePin: string;
    @field employed: boolean;
    @field employeeCode: string;
    @field wpsRestricted: boolean;
    @component accessRole: AccessRoleReferenceData;
    @field roles: string[];
    @component biometric: UserBiometricData;

    persistedBiometric: UserBiometricData;

    @transientField get enableBiometric(): boolean {
        return this.persistedBiometric && this.persistedBiometric.userBiometricId != undefined;
    }

    @transientField get hasBiometric(): boolean {
        return this.biometric && this.biometric.userBiometricId != undefined;
    }

    set hasBiometric(hasBiometric: boolean) {
        this.biometric = hasBiometric ? this.persistedBiometric : null;
    }
}

export class EmployeeData extends LocalisableEntityData<EmployeeData> {
    @identifier employeeId: number;
    @field status: string;
    @dateField startDate: Date;
    @field comments: string;
    @component contact: ContactData;
    @component position: PositionData;
    @component user: UserData;
    @field hourlyRate: number;

    get fullName(): string {
        return this.user.firstName + " " + this.user.lastName;
    }

    set fullName(name: string) {
        const str: string[] = name.split(" ");
        this.user.firstName = str[0];
        this.user.lastName = str[1];
    }

    override onLoad(): void {
        this.user.persistedBiometric = this.user.biometric;
    }
}
